import React from 'react'
import './Track.css'

const Track = ({name, rowNum, toPlay, playing, playerPlaying, selected, instrument, handleTrackSelect}) => {
  const chooseTrackClass = () => {
    if (toPlay && playing && playerPlaying === 'started') return 'waiting'
    else if (selected && playing) return 'playing'
    else if (selected) return 'selected'
    else return 'deselected'
  }
  return (
    <div className='trackBox'>
      <button 
        className={'trackButton ' + chooseTrackClass() + ' row' + rowNum}
        instrument={instrument}
        name={name}
        onClick={() => handleTrackSelect(instrument, name)}
      >
        {name}
      </button>
    </div>
  )
}

export default Track


// WEBPACK FOOTER //
// ./src/Track/Track.js